import React from 'react';
import Confetti from 'react-confetti';

class ThankYou extends React.Component{
    render(){
        return(
            <React.Fragment>
            <div className='content-body' >
                <section className='thank-you' >
                    <h1> Thank You for registering! </h1>
                    <p>
                        Check your Email for Invite, 
                        If you have any query write to us at 
                        <span className='text-highlight' >
                           &nbsp; contact@businesstoys.in &nbsp;
                        </span>
                        <br />
                        Or call us at <a href='tel:+919036366831' className='text-highlight' >+91 808 842 6734</a>
                    </p>
                </section>
            </div>
            <Confetti
                numberOfPieces={180}
                width={window.innerWidth}
                height={window.innerHeight}
            />
            </React.Fragment>
        )
    }
};

export default ThankYou;